import * as React from "react";

import MultilineText from "@hl/base-components/lib/MultilineText";
import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import {
  Text,
  Group,
  Stack,
  useMantineTheme,
  Flex,
  ScrollArea,
  Button,
} from "@mantine/core";

import { TOOLS_URL } from "~config";
import CollectionCreatedBy from "~features/MintPage/CollectionCreatedBy";
import MarketplaceStatsFooter from "~features/MintPage/apollo/MarketplaceStatsFooter";
import useMintState from "~hooks/useMintState";

type CardFooterProps = {
  imageUrl?: string | null;
};

const MarketplaceFloatingHeader = ({ imageUrl }: CardFooterProps) => {
  const { collection, walletAddress, isSingleContractEdition, isERC1155 } =
    useMintState();
  const title = collection?.name || "";
  const theme = useMantineTheme();
  const { isMedium, isSmall } = useMantineMediaQueries({
    withInitialValues: true,
  });
  // const isMobile = useMediaQuery(`(max-width: 450px)`);
  const marketplaceStats = !isSingleContractEdition && !isERC1155 && (
    <Flex wrap="nowrap" py={10}>
      <MarketplaceStatsFooter isScrollable />
    </Flex>
  );

  return (
    <Stack
      spacing={0}
      sx={{
        borderBottom: `1px solid ${theme.colors.divider[0]}`,
        position: "sticky",
        top: "56px",
        background: theme.colors.primaryBackground[0],
        zIndex: 99,
      }}
      justify="center"
      mih={83}
      mx={isSmall ? -40 : -16}
    >
      <ScrollArea type="never">
        <Flex
          py="xs"
          px={isMedium ? 40 : 20}
          justify={isMedium ? "space-between" : "center"}
          align="center"
          gap={16}
          direction={isMedium ? "row" : "column"}
          sx={{ flexGrow: isMedium ? "unset" : 1 }}
        >
          <Group spacing="xs" noWrap miw={0} sx={{ flexShrink: 0 }}>
            <ResizedImage
              src={imageUrl}
              fit="contain"
              radius="md"
              height={48}
              width={48}
            />
            <Stack spacing={0} maw={600}>
              <Flex maw={"100%"}>
                <MultilineText
                  numLines="1"
                  weight={500}
                  size={isMedium ? "lg" : "md"}
                >
                  {title}
                </MultilineText>
              </Flex>

              <Flex justify="space-between" align="center" gap="xs">
                <Text size={isMedium ? "xs" : 10}>
                  <CollectionCreatedBy numLines="1" />
                </Text>
                <Group align="center">
                  {collection?.creatorAddresses?.some(
                    (evmAddress) => evmAddress.address === walletAddress
                  ) && (
                    <Flex>
                      <Button
                        component="a"
                        color={SECONDARY_COLOR}
                        size="xs"
                        href={TOOLS_URL.collections.manage.replace(
                          ":collectionId",
                          collection.id
                        )}
                      >
                        Manage collection
                      </Button>
                    </Flex>
                  )}
                </Group>
              </Flex>
            </Stack>
          </Group>
          {isMedium && marketplaceStats}
        </Flex>
      </ScrollArea>
      {!isMedium && <ScrollArea type="never">{marketplaceStats}</ScrollArea>}
    </Stack>
  );
};

export default MarketplaceFloatingHeader;
